module.exports = __webpack_public_path__ + "assets/images/announcement-occupancy-history.png";